import React, { memo, useMemo } from 'react'
import { Box } from '@chakra-ui/core'
import { PostWrapper } from 'components/Post'
import { Post } from 'redux/reducers/feed'
import { SectionHeader } from './SectionHeader'
import useLocaleText from 'components/useLocaleText'

interface PostsFilteredViewProps {
  handleOpenSelectedPost: (postID: string) => void
  userId: string
  unreadPosts: Post[]
  readPosts: Post[]
}

export const PostsFilteredView = memo(({ handleOpenSelectedPost, unreadPosts, readPosts }: PostsFilteredViewProps) => {
  const t_unread_posts = useLocaleText('unread_msgs')
  const t_read_posts = useLocaleText('t_all_msgs_btn')

  const sortedUserPosts = useMemo(() => {
    return [...unreadPosts, ...readPosts]
  }, [unreadPosts, readPosts])

  const hasAnyPosts = sortedUserPosts.length > 0

  if (!hasAnyPosts) {
    return null
  }

  return (
    <Box>
      {unreadPosts.length > 0 && (
        <>
          <SectionHeader title={t_unread_posts} />
          {unreadPosts.map((p) => (
            <PostWrapper
              key={p.post_id}
              isAllPostCollapsed={true}
              posts={[]}
              {...p}
              handleOpenSelectedPost={handleOpenSelectedPost}
              isPersonalViewMode={true}
            />
          ))}
        </>
      )}

      {readPosts.length > 0 && (
        <>
          <SectionHeader title={t_read_posts} />
          {readPosts.map((p) => (
            <PostWrapper
              key={p.post_id}
              isAllPostCollapsed={true}
              posts={[]}
              {...p}
              handleOpenSelectedPost={handleOpenSelectedPost}
              isPersonalViewMode={true}
            />
          ))}
        </>
      )}
    </Box>
  )
})
